export const CHANGE_STATUS = 'dashboard/CHANGE_STATUS';